/**
 * Service de gestion des bus
 * Centralise tous les appels API liés aux bus
 */
import apiService from './api.service';

class BusService {
  /**
   * Créer un bus
   */
  async createBus(busData) {
    return await apiService.post('bus', busData);
  }

  /**
   * Obtenir les bus par compagnie
   */
  async getBusesByCompany(companyId) {
    return await apiService.get(`bus/compagnie/${companyId}`);
  }

  /**
   * Mettre à jour un bus
   */
  async updateBus(busId, busData) {
    return await apiService.put(`bus/${busId}`, busData);
  }

  /**
   * Supprimer un bus
   */
  async deleteBus(busId) {
    return await apiService.delete(`bus/${busId}`);
  }

  /**
   * Obtenir les détails d'un bus
   */
  async getBusDetails(busId) {
    return await apiService.get(`bus/${busId}`);
  }

  /**
   * Associer un bus à une compagnie
   */
  async associateBusToCompany(associationData) {
    return await apiService.post('bus/associer', associationData);
  }
}

export default new BusService();
